import { FC } from 'react';
import { TFunction } from 'next-i18next';
import UniversalLink from 'src/common/components/UniversalLink';
import Typography from 'src/common/components/Typography';
import Icon from 'src/common/components/IconDS22';
import { buildImageSrc } from 'src/common/utils/imageHelpers';
import styles from './LandingPageListingCardMinimal.module.scss';

export type LandingPageListingCardMinimalProps = {
  // Expects hard-coded, curated title; not actual listing headline
  headline: string;
  listingUrl: string;
  location: string;
  photoUrl: string;
  rating: string;
  translationFunction?: TFunction;
};

const buildUrl = (photoUrl: string) => {
  if (photoUrl) {
    const url = new URL(photoUrl); // to standardize url structure
    const src = `${url.origin + url.pathname}`;
    return buildImageSrc(src, { w: 500 });
  }
  return undefined;
};

const LandingPageListingCardMinimal: FC<LandingPageListingCardMinimalProps> = ({
  headline,
  listingUrl,
  location,
  photoUrl,
  rating,
  translationFunction,
}) => (
  <UniversalLink
    href={listingUrl}
    className={styles.root}
  >
    {/* eslint-disable-next-line @next/next/no-img-element */}
    <img
      src={buildUrl(photoUrl)}
      alt={translationFunction ? translationFunction(headline) : headline}
      className={styles.image}
      loading="lazy"
    />
    <div className={styles.text}>
      <div className={styles.topLine}>
        <Typography
          size="body-l"
          type="p"
          weight="semibold"
          className={styles.title}
        >
          {translationFunction ? translationFunction(headline) : headline}
        </Typography>
        <div className={styles.rating}>
          <Icon
            id="star-filled"
            size="m"
          />
          <Typography
            size="body-l"
            weight="semibold"
            type="p"
            className={styles.rating}
          >
            {rating}
          </Typography>
        </div>
      </div>
      <Typography
        size="body-l"
        type="p"
        className={styles.description}
      >
        {translationFunction ? translationFunction(location) : location}
      </Typography>
    </div>
  </UniversalLink>
);

export default LandingPageListingCardMinimal;
